export default "__VITE_ASSET__yI3$0xP7__"